module.exports = __webpack_public_path__ + "img/LUB00361.43bcd15c.png";